/* Raw Florida honey landing page: size picker, add to cart, copy email, PostHog measurement.
   Events (all prefixed honey_, all carry page):
     honey_view                         page loaded
     honey_section_seen  {section}      first time a section scrolls into view
     honey_scroll        {depth}        25/50/75/100, once each
     honey_cta_click     {cta}          any element with data-rm-cta
     honey_size_pick     {product, size}
     honey_faq_open      {question}
     honey_add_to_cart   {product, variant_id, size, price, placement}
     honey_add_to_cart_error {product, message}
     honey_contact_copy
*/
(function () {
  var root = document.querySelector('[data-rm-honey]');
  if (!root) return;

  function track(ev, props) {
    try {
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture(ev, Object.assign({ page: location.pathname }, props || {}));
      }
    } catch (e) {}
  }
  track('honey_view');

  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.getAttribute('data-rm-section');
        if (seen[name]) return;
        seen[name] = true;
        track('honey_section_seen', { section: name });
      });
    }, { threshold: 0.3 });
    root.querySelectorAll('[data-rm-section]').forEach(function (el) { io.observe(el); });
  }

  var marks = [25, 50, 75, 100], fired = {};
  function onScroll() {
    var doc = document.documentElement, max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    var pct = Math.round(((window.scrollY || doc.scrollTop) / max) * 100);
    marks.forEach(function (m) { if (pct >= m && !fired[m]) { fired[m] = true; track('honey_scroll', { depth: m }); } });
    if (fired[100]) window.removeEventListener('scroll', onScroll);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  root.querySelectorAll('[data-rm-cta]').forEach(function (el) {
    el.addEventListener('click', function () { track('honey_cta_click', { cta: el.getAttribute('data-rm-cta') }); });
  });

  root.querySelectorAll('[data-rm-faq]').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) track('honey_faq_open', { question: d.getAttribute('data-rm-faq') }); });
  });

  /* Size picker: rewrites the card's Add button. */
  root.querySelectorAll('.rm-hn__offer').forEach(function (card) {
    var btn = card.querySelector('[data-rm-add]');
    if (!btn) return;
    card.querySelectorAll('.rm-hn__size input').forEach(function (r) {
      r.addEventListener('change', function () {
        card.querySelectorAll('.rm-hn__size').forEach(function (l) { l.classList.toggle('is-selected', l.contains(r)); });
        btn.setAttribute('data-variant-id', r.value);
        btn.setAttribute('data-price', r.getAttribute('data-price'));
        btn.setAttribute('data-size', r.getAttribute('data-size'));
        var p = btn.querySelector('[data-rm-add-price]');
        if (p) p.textContent = r.getAttribute('data-money');
        track('honey_size_pick', { product: btn.getAttribute('data-product'), size: r.getAttribute('data-size') });
      });
    });
  });

  /* Add to cart: the same request Dawn's product form makes, so the cart drawer opens. */
  root.querySelectorAll('[data-rm-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var vid = btn.getAttribute('data-variant-id');
      var product = btn.getAttribute('data-product');
      var drawer = document.querySelector('cart-drawer');
      var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var label = btn.innerHTML;
      btn.disabled = true; btn.textContent = 'Adding…';
      var fd = new FormData();
      fd.append('id', vid);
      fd.append('quantity', '1');
      if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', location.pathname); }
      fetch(addUrl + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message || 'add failed');
          track('honey_add_to_cart', { product: product, variant_id: vid, size: btn.getAttribute('data-size'),
            price: parseFloat(btn.getAttribute('data-price') || '0'), placement: btn.getAttribute('data-rm-placement') });
          if (drawer && json.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(json);
          } else {
            location.href = cartUrl;
          }
        })
        .catch(function (e) {
          track('honey_add_to_cart_error', { product: product, message: String(e && e.message) });
          location.href = cartUrl;
        })
        .then(function () { btn.disabled = false; btn.innerHTML = label; });
    });
  });

  /* Copy the gift-orders email. */
  var copyBtn = root.querySelector('[data-rm-copy-btn]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var v = root.querySelector('[data-rm-copy]');
      var text = v ? v.getAttribute('data-rm-copy') : '';
      var done = function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800); };
      track('honey_contact_copy');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { selectText(v); });
      } else { selectText(v); }
    });
  }
  function selectText(el) {
    if (!el || !window.getSelection) return;
    var range = document.createRange(); range.selectNodeContents(el);
    var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
  }
})();
